<div class="p-4 signupcard">
    <form id="signup" [formGroup]="signUpForm" (submit)="signUpForm.valid && signUp()">

        <h5 i18n="@@personalInfo">Personal Information</h5>
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <div class="form-group">
                    <label i18n>Email</label>
                    <input type="email"
                           id="new_email"
                           (focusout)="checkEmailExists()"
                           name="user_email"
                           class="form-control"
                           [ngClass]="{'is-invalid':signUpForm.get('new_email').touched && signUpForm.get('new_email').invalid}"
                           formControlName="new_email"
                           autocomplete="off"
                           required=""

                    >
                    <div class="invalid-feedback">
                        <div i18n>Email is required</div>
                    </div>
                    <div style="color:red;" *ngIf="emailExists">
                        This email is already registered, please <a href="#" (click)="showLogin($event)">click here</a>
                        to
                        login.
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-6">
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12 col-md-6">
                <div class="form-group">
                    <label i18n>First Name</label>
                    <input type="text"
                           id="first_name"
                           name="first_name"
                           (ngModelChange)=" changeAddressFirstName($event)"
                           class="form-control"
                           [ngClass]="{'is-invalid':signUpForm.get('first_name').touched && signUpForm.get('first_name').invalid}"
                           formControlName="first_name"
                           autocomplete="off"
                           required=""

                    >
                    <div class="invalid-feedback">
                        <div i18n>First Name is required</div>
                    </div>
                </div>

            </div>
            <div class="col-sm-12 col-md-6">

                <div class="form-group">
                    <label i18n>Last Name</label>
                    <input type="text"
                           id="last_name"
                           name="last_name"
                           (ngModelChange)=" changeAddressLastName($event)"
                           class="form-control"
                           [ngClass]="{'is-invalid':signUpForm.get('last_name').touched && signUpForm.get('last_name').invalid}"
                           formControlName="last_name"
                           autocomplete="off"
                           required=""

                    >
                    <div class="invalid-feedback">
                        <div i18n>Last Name is required</div>
                    </div>
                </div>
            </div>
        </div>


        <div class="row">
            <div class="col-sm-12 col-md-6">

                <div class="form-group">
                    <label i18n>Password</label>
                    <input type="password"
                           id="new_password"
                           name="user_password"
                           class="form-control"
                           [ngClass]="{'is-invalid':signUpForm.get('new_password').touched && signUpForm.get('new_password').invalid}"
                           formControlName="new_password"
                           autocomplete="off"
                           required=""

                    >
                    <div class="invalid-feedback">
                        <div i18n>Password is required</div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-6">
                <div class="form-group">
                    <label i18n>Confirm Password</label>
                    <input type="password"
                           id="confirm_password"
                           name="confirm_password"
                           class="form-control"
                           [ngClass]="{'is-invalid':signUpForm.get('confirm_password').touched && signUpForm.get('confirm_password').invalid}"
                           formControlName="confirm_password"
                           autocomplete="off"
                           required=""

                    >
                    <div class="invalid-feedback">
                        <div i18n>Confirm Password is required</div>
                    </div>
                </div>
            </div>

        </div>

        <br>
        <h5 i18n="@@billingInfo">Billing Information</h5>


        <div class="row">
            <div class="col-sm-12 col-md-6">

                <div class="form-group">
                    <label i18n>First name</label>
                    <input type="text"
                           id="address_first_name"
                           placeholder=""
                           [ngClass]="{'is-invalid':signUpForm.get('address_first_name').touched && signUpForm.get('address_first_name').invalid}"
                           class="form-control"
                           formControlName="address_first_name"
                           required="" ngModel
                           aria-required="true">
                    <div class="invalid-feedback">
                        <div i18n>Address first name is required</div>
                    </div>
                </div>
            </div>

            <div class="col-sm-12 col-md-6">
                <div class="form-group">
                    <label i18n>Last name</label>
                    <input type="text"
                           id="address_last_name"
                           name="address_last_name"
                           placeholder=""
                           [ngClass]="{'is-invalid':signUpForm.get('address_last_name').touched && signUpForm.get('address_last_name').invalid}"
                           class="form-control"
                           formControlName="address_last_name"
                           required="" ngModel
                           aria-required="true">
                    <div class="invalid-feedback">
                        <div i18n>Address last name is required</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">


            <div class="col-md-3 col-sm-12">
                <div class="form-group">
                    <label i18n>City</label>
                    <input type="text"
                           id="city"
                           name="city"
                           placeholder=""
                           [ngClass]="{'is-invalid':signUpForm.get('city').touched && signUpForm.get('city').invalid}"
                           class="form-control"
                           formControlName="city"
                           required="" ngModel
                           aria-required="true">
                    <div class="invalid-feedback">
                        <div i18n>City is required</div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-12">
                <div class="form-group">
                    <label i18n>Street</label>
                    <input type="text"
                           id="street"
                           name="street"
                           placeholder=""
                           [ngClass]="{'is-invalid':signUpForm.get('street').touched && signUpForm.get('street').invalid}"
                           class="form-control"
                           formControlName="street"
                           required="" ngModel
                           aria-required="true">
                    <div class="invalid-feedback">
                        <div i18n>Street is required</div>
                    </div>
                </div>
            </div>

            <div class="col-md-3 col-sm-12">

                <div class="form-group">
                    <label i18n>Phone</label>
                    <input type="text"
                           id="phone"
                           name="street"
                           placeholder=""
                           [ngClass]="{'is-invalid':signUpForm.get('phone').touched && signUpForm.get('phone').invalid}"
                           class="form-control"
                           formControlName="phone"
                           required="" ngModel
                           aria-required="true">
                    <div class="invalid-feedback">
                        <div i18n>Phone is required</div>
                    </div>
                </div>
            </div>

        </div>
        <div>

            <div class="text-right mt-5 p-4 ">

                <button id="new_user_btn" class="btn btn-success"
                        type="submit"
                >
                                              <span style="width: 40px;">
                    <img src="assets/loader.gif" style="width: 20px !important;" *ngIf="isLoggingIn"/>
                    <i style="width: 20px " class="la la-arrow-right" *ngIf="!isLoggingIn"></i>
                    </span>
                    <label (click)="signUp()" i18n="@@signupbtn">Sign Up</label>
                </button>

            </div>
        </div>


    </form>


</div>
